import type { SVGProps } from "react";

export function MenuIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15 21H6C5.20435 21 4.44129 20.6839 3.87868 20.1213C3.31607 19.5587 3 18.7957 3 18V17H13V19C13 19.5304 13.2107 20.0391 13.5858 20.4142C13.9609 20.7893 14.4696 21 15 21ZM15 21C15.5304 21 16.0391 20.7893 16.4142 20.4142C16.7893 20.0391 17 19.5304 17 19V5C17 4.60444 17.1173 4.21776 17.3371 3.88886C17.5568 3.55996 17.8692 3.30362 18.2346 3.15224C18.6001 3.00087 19.0022 2.96126 19.3902 3.03843C19.7781 3.1156 20.1345 3.30608 20.4142 3.58579C20.6939 3.86549 20.8844 4.22186 20.9616 4.60982C21.0387 4.99778 20.9991 5.39992 20.8478 5.76537C20.6964 6.13082 20.44 6.44318 20.1111 6.66294C19.7822 6.8827 19.3956 7 19 7H17M19 3H8C7.20435 3 6.44129 3.31607 5.87868 3.87868C5.31607 4.44129 5 5.20435 5 6V17M9 7H13M9 11H13"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function MenuAltIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4 6H20"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4 12H20"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4 18H20"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function MenuOffIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15 21H6C5.20435 21 4.44129 20.6839 3.87868 20.1213C3.31607 19.5587 3 18.7956 3 18V17H13V19C13 19.5304 13.2107 20.0391 13.5858 20.4142C13.9609 20.7893 14.4696 21 15 21ZM15 21C15.5304 21 16.0391 20.7893 16.4142 20.4142C16.7893 20.0391 17 19.5304 17 19V17M17 7H19C19.3956 7 19.7822 6.8827 20.1111 6.66294C20.44 6.44318 20.6964 6.13082 20.8478 5.76537C20.9991 5.39992 21.0387 4.99778 20.9616 4.60982C20.8844 4.22186 20.6939 3.86549 20.4142 3.58579C20.1345 3.30608 19.7781 3.1156 19.3902 3.03843C19.0022 2.96126 18.6001 3.00087 18.2346 3.15224C17.8692 3.30362 17.5568 3.55996 17.3371 3.88886C17.1173 4.21776 17 4.60444 17 5V13M19 3H8C7.70223 3 7.40901 3.04427 7.12917 3.12917M5 17V6C5 5.70223 5.04427 5.40902 5.12917 5.12917M13 7H11M9 11H11M3 3L5.12917 5.12917M21 21L17 17M17 17L11 11M11 11L5.12917 5.12917"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function MenuSendIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17 7H19C19.3956 7 19.7822 6.8827 20.1111 6.66294C20.44 6.44318 20.6964 6.13082 20.8478 5.76537C20.9991 5.39992 21.0387 4.99778 20.9616 4.60982C20.8844 4.22186 20.6939 3.86549 20.4142 3.58579C20.1345 3.30608 19.7781 3.1156 19.3902 3.03843C19.0022 2.96126 18.6001 3.00087 18.2346 3.15224C17.8692 3.30362 17.5568 3.55996 17.3371 3.88886C17.1173 4.21776 17 4.60444 17 5V12V14.5M19 3H8C7.20435 3 6.44129 3.31607 5.87868 3.87868C5.31607 4.44129 5 5.20435 5 6V17M9 7H13M9 11H13M11.5 17H8H3V18C3 18.7957 3.31607 19.5587 3.87868 20.1213C4.44129 20.6839 5.20435 21 6 21H10.5M14 20H20M20 20L17 17M20 20L17 23"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function MenuCheckIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17 7H19C19.3956 7 19.7822 6.8827 20.1111 6.66294C20.44 6.44318 20.6964 6.13082 20.8478 5.76537C20.9991 5.39992 21.0387 4.99778 20.9616 4.60982C20.8844 4.22186 20.6939 3.86549 20.4142 3.58579C20.1345 3.30608 19.7781 3.1156 19.3902 3.03843C19.0022 2.96126 18.6001 3.00087 18.2346 3.15224C17.8692 3.30362 17.5568 3.55996 17.3371 3.88886C17.1173 4.21776 17 4.60444 17 5V12V14.5M19 3H8C7.20435 3 6.44129 3.31607 5.87868 3.87868C5.31607 4.44129 5 5.20435 5 6V17M9 7H13M9 11H13M15 19L17 21L21 17M11.5 17H8H3V18C3 18.7957 3.31607 19.5587 3.87868 20.1213C4.44129 20.6839 5.20435 21 6 21H10.5"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
